/**
 * @description 个人相关接口
 * @author 有界前端团队
 * @date 2024-05-28
 */
import request from '@/utils/request'

/**
 * 获取当前用户信息
 * @returns {Promise<Object>} 用户信息对象
 */
export function requestCurrentInfo() {
  return request({
    url: '/person/currentInfo',
    method: 'post'
  })
} 

// 更新用户密码
export function requestUpdatePassword(data) {
  return request({
    url: '/person/updatePassword',
    method: 'post',
    data
  })
} 